import { render, staticRenderFns } from "./mobile-menu.vue?vue&type=template&id=07d27dfb&"
import script from "./mobile-menu.vue?vue&type=script&lang=js&"
export * from "./mobile-menu.vue?vue&type=script&lang=js&"
import style0 from "./mobile-menu.vue?vue&type=style&index=0&id=07d27dfb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports